// Start/end time checks for schedule forms. Mirrors App\Helpers\ScheduleTimes on the API:
// a timed entry must end after it starts, so "12:00 - 09:00" is rejected rather than
// saved and later counted as negative (or doubled) hours in the reports.

export const INVALID_TIME_RANGE_MESSAGE =
  "End time must be after start time. For a shift that runs to midnight use 23:59.";

// "HH:mm" or "HH:mm:ss" -> minutes since midnight, or null when empty/unparseable
export function toMinutes(time) {
  if (!time || typeof time !== "string") return null;
  const match = time.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

// Untimed entries (either side empty) are allowed, same as the API.
export function isValidTimeRange(start, end) {
  const s = toMinutes(start);
  const e = toMinutes(end);
  if (s === null || e === null) return true;
  return e > s;
}

// When the start moves to or past the end, push the end forward instead of leaving
// a backwards range for the user to notice. Returns the (possibly unchanged) end time.
// maxTime is the end picker's own limit (e.g. "12:00" for an AM slot), if it has one.
export function bumpEndTime(start, end, minutes = 60, maxTime = "23:59") {
  if (isValidTimeRange(start, end)) return end;
  const s = toMinutes(start);
  const limit = toMinutes(maxTime);
  const bumped = Math.min(s + minutes, limit === null ? 23 * 60 + 59 : limit);
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(Math.floor(bumped / 60))}:${pad(bumped % 60)}`;
}

// Message for a failed save: the API's 422 text when there is one, else the fallback.
export function apiErrorMessage(error, fallback = "Something went wrong.") {
  const data = error && error.response && error.response.data;
  if (data && data.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first.length) return first[0];
  }
  return (data && data.message) || fallback;
}
